export const environment = {
  production: true,
  fallbackLocale: 'es-CL',
  tenant: 'activities_CHL',
  widget: false,
  serviceWorker: {
      enable: true,
  },
  e2e: {
    // enable e2e mode with data-test markup
    enable: false,
  },
  applications: {
    datadog: {
      applicationId: 'f2062e7c-738c-4e68-80c7-431aede71afb',
      clientToken: 'pub479f0afae0f5f45fa57ee25866064036',
    },
    unleash: {
         environment: 'production',
        alwaysEnableFeatures: false,
        secret: '!A0/|:cW@SLj^3.MSQx)',
        proxyUrl: 'https://actividades.decathlon.cl/unleash-proxy/proxy',
        refreshInterval: '0',
     },
    cdn: {
      host: 'https://activities-assets.decathlon.net/legacy',
      root: "https://activities-assets.decathlon.net",
    },
    phrase: {
      url: 'https://api.phrase.com/v2/projects/64e9e1e8548ff83e70869d39c3bcc808/locales/:localeId/download?file_format=nested_json',
      token: '17850ae8c11cf53f8b5716ab66ba815a23331fd6f7b8d1ebb82f1a76c1a13192',
      locales: {
        'es-CL': '63ee70392d06dd614b808d6a0c36afdb',
      },
    },
    front: {
      url: 'https://actividades.decathlon.cl',
      domain: 'actividades.decathlon.cl',
    },
    woosmap: {
      apiKey: 'woos-6e588fc5-a1e3-3d39-9ee1-28b713fdd5df',
      gmapApiKey: 'AIzaSyDG3jq0cm9JoLe9E8PCAZaawAHrfQ7U_ss',
      locale: 'country:cl',
    },
    amplitude: {
      apiKey: 'c06224e8147966f6ffae12a7f2d7d198',
    },
    gtm: {
      id: 'GTM-MTM3WV9',
    },
    sentry: {
      dsn: 'https://0fc1729944bc4fa1a21e1cab26bd34ad@sentry.io/1396593',
      environment: 'production-CHL',
      enabled: true
    },
    talkjs: {
       appId: 'QFqHH3hk',
    },
    activities: {
      url: 'https://api-eu.decathlon.net/activities/v2',
      api_key: '9f8e0453-b593-48db-a02a-9b7984d044ec',
    },
    strapi: {
      url: 'https://actividades.decathlon.cl/strapi-api',
      locale: '',
    },
    stripe: {
      apiKey: 'pk_live_HHUBQrl2UIew34g2aC6haMxJ00HnLYVoVA',
      authorizeUri: 'https://connect.stripe.com/express/oauth/authorize',
      apiUrl: 'https://connect.stripe.com'
    },
    pfs: {
      url: 'https://europe-west1-services-platform-pwlg.cloudfunctions.net/api'
    },
  advice: {
       url: 'https://api-global.decathlon.net/cms',
       apiKey: 'c1bd69cf-9822-49be-819a-a42dd47cb043',
    },
    reviews: {
      url: 'https://reviews-collect-eu.satisphere.decathlon.net',
    },
    onepay: {
      apiKey: 'TODO',
      entityId: 'TODO', 
      host: 'TODO',
      apiBaseUrl: 'https://api-eu.decathlon.net/payments',
    },
    partner: {
      onboardingRedirect: 'https://partner.decathlon.com/activities/login'
    },
  },
  auth: {
    fed: {
      issuer: 'https://idpdecathlon.oxylane.com',
      redirectUri: 'https://actividades.decathlon.cl/auth/redirection',
      clientId: 'Cc73544e2464f2bbb5585c8508f0d4ceba0afa720',
      userinfoEndpoint:
        'https://idpdecathlon.oxylane.com/idp/userinfo.openid',
      discoveryDocument:
        'https://idpdecathlon.oxylane.com/.well-known/openid-configuration',
    },
    connect: {
      issuer: 'https://api-eu.decathlon.net/connect',
      redirectUri: 'https://actividades.decathlon.cl/auth/redirection',
      clientId: '5d5dd746-239a-4491-b916-78e020ec1377',
      discoveryDocument:
        'https://api-global.decathlon.net/connect/.well-known/openid-configuration',
      logoutRedirectionUrl: 'https://actividades.decathlon.cl/auth/logout',
    },
  },
};
